import { render, staticRenderFns } from "./mem_block_right.vue?vue&type=template&id=fa9359ac&scoped=true&"
import script from "./mem_block_right.vue?vue&type=script&lang=js&"
export * from "./mem_block_right.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9359ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa9359ac')) {
      api.createRecord('fa9359ac', component.options)
    } else {
      api.reload('fa9359ac', component.options)
    }
    module.hot.accept("./mem_block_right.vue?vue&type=template&id=fa9359ac&scoped=true&", function () {
      api.rerender('fa9359ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/body/sides/mem_block_right.vue"
export default component.exports